import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker as MuiTimePicker, TimePickerProps as MuiTimePickerProps } from '@mui/x-date-pickers/TimePicker';
import React from 'react';
import { HoverIcon } from '@fox/layout/src/style';
import { ExtendedTextFieldProps } from '@fox/atoms/src/text-field/index';

export interface TimePickerProps<TDate> extends MuiTimePickerProps<TDate>, Pick<ExtendedTextFieldProps, 'InputProps'> {}

export const TimePicker = (props: TimePickerProps<Date>) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<MuiTimePicker
				slots={{
					textField: TextField
				}}
				{...props}
				// TODO: I don't like this slotProps hackery, it fixes styling issues inside custom fields wrapper
				// but a better solution should be found when adding TimePicker to Storybook.
				slotProps={{
					textField: {
						fullWidth: true,
						size: 'small',
						InputProps: {
							style: { marginRight: '0px' }
						}
					},
					inputAdornment: {
						component: HoverIcon,
						position: 'end',
						style: { overflow: 'visible' }
					} as any
				}}
			/>
		</LocalizationProvider>
	);
};
